@if (pageTitle) {
  <h2 class="mb-0 ellipse text-left" [innerHTML]="pageTitle"></h2>
}
@if (subTitle) {
  <h3 class="mb-0 ellipse text-left"><span [innerHTML]="subTitle"></span></h3>
}

<h2 class="ellipse text-left"><ng-content></ng-content></h2>
